module.exports = __webpack_public_path__ + "img/2023-06.f0ce74c5.jpg";